import { render, staticRenderFns } from "./w-field.vue?vue&type=template&id=a2d111f4&scoped=true"
import script from "./w-field.vue?vue&type=script&lang=ts"
export * from "./w-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d111f4",
  null
  
)

export default component.exports